<template>
	<div>

		<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup">
			<tbody>

				<tr>
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="redirects">

							<h5>Redirects</h5>
							<p>http://www.obumex.be/home<br>http://www.obumex.be/startpagina</p>

							<h5>Aliassen</h5>
							<p>
								<span class="status active"></span> http://www.obumex.be/splash<br> <span class="status active"></span>
								http://www.obumex.be/splash<br> <span class="status"></span> http://www.obumex.be/splash
							</p>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level1">
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="redirects">

							<p>301: http://www.obumex.be/home</p>

						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr>
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="redirects">

							<h5>Redirects</h5>
							<p>http://www.obumex.be/home<br>http://www.obumex.be/startpagina</p>

							<h5>Aliassen</h5>
							<p>
								<span class="status active"></span> http://www.obumex.be/splash<br> <span class="status active"></span>
								http://www.obumex.be/splash<br> <span class="status"></span> http://www.obumex.be/splash
							</p>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level1">
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="redirects">

							<p>301: http://www.obumex.be/home</p>

						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr>
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="redirects">

							<h5>Redirects</h5>
							<p>http://www.obumex.be/home<br>http://www.obumex.be/startpagina</p>

							<h5>Aliassen</h5>
							<p>
								<span class="status active"></span> http://www.obumex.be/splash<br> <span class="status active"></span>
								http://www.obumex.be/splash<br> <span class="status"></span> http://www.obumex.be/splash
							</p>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level1">
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="redirects">

							<p>301: http://www.obumex.be/home</p>

						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

			</tbody>
		</table>

	</div>

</template>

<script>

export default {
	name: 'headers'
}
</script>
